"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var useZoomPercentage = function useZoomPercentage() {
  var _useState = (0, _react.useState)(100),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    zoomPercentage = _useState2[0],
    setZoomPercentage = _useState2[1];
  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      var outerWidth = window.outerWidth;
      var innerWidth = window.innerWidth;
      setZoomPercentage(Math.round(outerWidth / innerWidth * 100));
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return zoomPercentage;
};
var _default = useZoomPercentage;
exports.default = _default;